module.exports = __webpack_public_path__ + "media/bootstrap-icons/three-dots-vertical-ea85c632.svg";